module.exports = __webpack_public_path__ + "static/img/3.f7366f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjiancase/3.png
// module id = sWWU
// module chunks = 19